module.exports = __webpack_public_path__ + "img/fd-logo.32f636d1.png";